var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-active",class:{bottom: _vm.position === 'bottom'}},[_c('div',{staticClass:"menu"},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"m-item",on:{"click":function($event){$event.stopPropagation();return _vm.callback(item)}}},[_c('span',[_vm._v(_vm._s(item))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }